if (!customElements.get('betty-cart-progress')) {
  const selector = 'betty-cart-progress[data-betty-cart-progress]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fills = new Map();
  const celebrations = new Map();
  const tierFor = (count) => count >= 3 ? 30 : count >= 2 ? 20 : 0;
  const countFor = (element) => Math.max(0, Number(element?.dataset.pairCount) || 0);
  const initialCount = countFor(document.querySelector(selector));
  const state = {count: initialCount, pendingTier: 0, frame: 0};
  const colors = ['#eb654f', '#c69745', '#fff3cf', '#a54134'];

  function updateRecommendationHeadings(count) {
    document.querySelectorAll('[data-betty-cart-recommendation-heading]').forEach((heading) => {
      const text = count >= 3 ? heading.dataset.moreHeading : heading.dataset.nextHeading;
      if (text && heading.textContent !== text) heading.textContent = text;
      heading.dataset.pairCount = String(count);
    });
  }

  function stopCelebration(element) {
    const celebration = celebrations.get(element);
    if (!celebration) return;
    window.clearTimeout(celebration.timer);
    celebration.animations.forEach((animation) => animation.cancel());
    if (celebration.layer.hidePopover && celebration.layer.hasAttribute('popover')) {
      try { celebration.layer.hidePopover(); } catch {}
    }
    celebration.layer.remove();
    element.removeAttribute('data-celebrating');
    celebrations.delete(element);
  }

  function stopFill(element) {
    fills.get(element)?.cancel();
    fills.delete(element);
  }

  function isVisible(element) {
    return document.visibilityState !== 'hidden' && element.getClientRects().length > 0;
  }

  function animateFill(element, previousCount, nextCount) {
    stopFill(element);
    if (reducedMotion.matches || !isVisible(element)) return;
    const fill = element.querySelector('.betty-cart-progress__fill');
    if (!fill?.animate) return;
    const animation = fill.animate([
      {transform: `scaleX(${Math.min(previousCount, 3) / 3})`},
      {transform: `scaleX(${Math.min(nextCount, 3) / 3})`},
    ], {duration: 420, easing: 'cubic-bezier(.22, 1, .36, 1)'});
    fills.set(element, animation);
    animation.finished.then(() => {
      if (fills.get(element) === animation) fills.delete(element);
    }).catch(() => {});
  }

  function celebrate(element, tier) {
    if (!element.animate) return;
    [...celebrations.keys()].forEach(stopCelebration);
    const layer = document.createElement('div');
    layer.className = 'betty-cart-progress__confetti';
    layer.setAttribute('aria-hidden', 'true');
    layer.setAttribute('data-betty-confetti', String(tier));
    const fragment = document.createDocumentFragment();
    const particles = [];
    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    const viewportHeight = window.innerHeight;
    const isSmallScreen = viewportWidth < 750;
    const count = tier === 30 ? (isSmallScreen ? 54 : 90) : (isSmallScreen ? 36 : 64);

    for (let index = 0; index < count; index++) {
      const particle = document.createElement('span');
      particle.className = 'betty-cart-progress__particle';
      particle.style.left = `${Math.random() * 100}%`;
      particle.style.top = '-16px';
      particle.style.backgroundColor = colors[index % colors.length];
      fragment.append(particle);
      particles.push(particle);
    }

    layer.append(fragment);
    if (typeof layer.showPopover === 'function') {
      layer.setAttribute('popover', 'manual');
      document.body.append(layer);
      try {
        layer.showPopover();
      } catch {
        layer.removeAttribute('popover');
        (element.closest('dialog[open]') || document.body).append(layer);
      }
    } else {
      (element.closest('dialog[open]') || document.body).append(layer);
    }
    element.dataset.celebrating = String(tier);
    const animations = [element.animate([
      {transform: 'scale(1)'},
      {transform: `scale(${tier === 30 ? 1.018 : 1.012})`, offset: .25},
      {transform: 'scale(1)'},
    ], {duration: 680, easing: 'ease-out'})];

    const milestone = element.querySelectorAll('.betty-cart-progress__milestone')[tier === 30 ? 1 : 0];
    if (milestone?.animate) animations.push(milestone.animate([
      {transform: 'translateY(0)'},
      {transform: 'translateY(-3px)', offset: .35},
      {transform: 'translateY(0)'},
    ], {duration: 620, easing: 'ease-out'}));

    particles.forEach((particle, index) => {
      const horizontal = (Math.random() - .5) * Math.min(viewportWidth * .25, 180);
      const start = -Math.random() * viewportHeight * .25;
      const fall = viewportHeight + 32;
      const rotation = (index % 2 ? 1 : -1) * (180 + Math.random() * 360);
      animations.push(particle.animate([
        {transform: `translate3d(0, ${start}px, 0) rotate(0deg)`, opacity: 0},
        {transform: `translate3d(${horizontal * .25}px, ${viewportHeight * .1}px, 0) rotate(${rotation * .25}deg)`, opacity: 1, offset: .18},
        {transform: `translate3d(${horizontal * .75}px, ${viewportHeight * .7}px, 0) rotate(${rotation * .75}deg)`, opacity: 1, offset: .75},
        {transform: `translate3d(${horizontal}px, ${fall}px, 0) rotate(${rotation}deg)`, opacity: 0},
      ], {duration: 1180 + Math.random() * 160, delay: Math.random() * 80, easing: 'linear', fill: 'both'}));
    });

    const timer = window.setTimeout(() => stopCelebration(element), 1500);
    celebrations.set(element, {layer, animations, timer, tier});
  }

  function update() {
    state.frame = 0;
    const elements = [...document.querySelectorAll(selector)];
    const nextCount = elements.reduce((count, element) => Math.max(count, countFor(element)), 0);
    const previousCount = state.count;
    state.count = nextCount;
    const nextTier = tierFor(nextCount);
    const summaries = [...document.querySelectorAll('betty-cart-quantity-summary')];
    if (summaries.length || elements.length) {
      const headingCount = summaries.length ? summaries.reduce((count, element) => Math.max(count, countFor(element)), 0) : nextCount;
      updateRecommendationHeadings(headingCount);
    }

    for (const [element, celebration] of celebrations) {
      if (!elements.length || nextTier < celebration.tier || document.visibilityState === 'hidden') {
        stopCelebration(element);
      }
    }

    if (nextTier > tierFor(previousCount)) {
      state.pendingTier = nextTier;
    } else if (nextCount === 0 || nextTier < state.pendingTier) {
      state.pendingTier = 0;
    }

    if (nextCount !== previousCount) {
      elements.forEach((element) => animateFill(element, previousCount, nextCount));
    }

    if (!state.pendingTier) return;
    const element = elements.find(isVisible);
    if (!element) return;
    const tier = state.pendingTier;
    state.pendingTier = 0;
    if (!reducedMotion.matches) celebrate(element, tier);
  }

  function scheduleUpdate() {
    if (!state.frame) state.frame = requestAnimationFrame(update);
  }

  class BettyCartProgress extends HTMLElement {
    static observedAttributes = ['data-pair-count'];
    #dialogObserver;

    connectedCallback() {
      const dialog = this.closest('dialog');
      if (dialog) {
        this.#dialogObserver = new MutationObserver(scheduleUpdate);
        this.#dialogObserver.observe(dialog, {attributes: true, attributeFilter: ['open']});
      }
      scheduleUpdate();
    }

    attributeChangedCallback() {
      scheduleUpdate();
    }

    disconnectedCallback() {
      this.#dialogObserver?.disconnect();
      stopFill(this);
      scheduleUpdate();
    }
  }

  customElements.define('betty-cart-progress', BettyCartProgress);
  customElements.define('betty-cart-quantity-summary', class extends HTMLElement {
    static observedAttributes = ['data-pair-count'];

    connectedCallback() {
      scheduleUpdate();
    }

    attributeChangedCallback() {
      scheduleUpdate();
    }

    disconnectedCallback() {
      scheduleUpdate();
    }
  });
  document.addEventListener('cart:update', scheduleUpdate);
  document.addEventListener('visibilitychange', scheduleUpdate);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      [...fills.keys()].forEach(stopFill);
      [...celebrations.keys()].forEach(stopCelebration);
    }
    scheduleUpdate();
  });
}
